var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Api } from './api';
import * as i0 from "@angular/core";
import * as i1 from "./api";
export class ReportsApi {
    constructor(api) {
        this.api = api;
    }
    getVisibleAssetIds(layerId, columnName, query) {
        return __awaiter(this, void 0, void 0, function* () {
            if (query) {
                return yield this.api.http2.graphqlRequest(`
                    query ($query: QueryInput!) {
                        layers(id: ${layerId}){
                            data(fieldNames: ["${columnName}"], query: $query)
                        }
                    }
            `, { query }, 'GET', 'layers');
            }
            else {
                return yield this.api.http2.graphqlRequest(`
                    query {
                        layers(id: ${layerId}){
                            data(fieldNames: ["${columnName}"])
                        }
                    }
            `, {}, 'GET', 'layers');
            }
        });
    }
    getProjectTotals(ids) {
        return this.api.report.post('api/reports/getProjectTotals', ids);
    }
    getBridgeReportData(bridgeId) {
        return this.api.report.get('api/reports/bridgeReport', { bridgeId }).catch(err => { throw err; });
    }
    getBridgeBasicReportData(bridgeId) {
        return this.api.report.get('api/reports/basicBridgeReport', { bridgeId }).catch(err => { throw err; });
    }
    getBridgeDataReportData(ids) {
        return this.api.report.post('api/reports/bridgeDataReport', ids).catch(err => { throw err; });
    }
    getProjectListReportData(ids) {
        return this.api.report.post('api/reports/projectList', ids).catch(err => { throw err; });
    }
    getIRIProjectEvaluationDraftTIPReportData(reportParams) {
        return this.api.report.post('api/reports/IRIProjectEvaluationDraftTIPReport', reportParams).catch(err => { throw err; });
    }
    getIRIProjectEvaluationTIPReportData(reportParams) {
        return this.api.report.post('api/reports/IRIProjectEvaluationTIPReport', reportParams).catch(err => { throw err; });
    }
    getOPIProjectEvaluationDraftTIPReportData(reportParams) {
        return this.api.report.post('api/reports/OPIProjectEvaluationDraftTIPReport', reportParams).catch(err => { throw err; });
    }
    getOPIProjectEvaluationTIPReportData(reportParams) {
        return this.api.report.post('api/reports/OPIProjectEvaluationTIPReport', reportParams).catch(err => { throw err; });
    }
    getPlanningStatsDraftTipReportData(planningPartner) {
        return this.api.report.get('api/reports/planningStatsDraftTipReport', { planningPartner }).catch(err => { throw err; });
    }
    getPlanningStatsTipReportData(planningPartner) {
        return this.api.report.get('api/reports/planningStatsTipReport', { planningPartner }).catch(err => { throw err; });
    }
    getProjectDetailReportData(projectId) {
        return this.api.report.get('api/reports/projectDetail', { projectId }).catch(err => { throw err; });
    }
    getProjectStatusReportData(projectId) {
        return this.api.report.get('api/reports/projectStatus', { projectId }).catch(err => { throw err; });
    }
    getSDBridgeReportData(bridgeIds) {
        return this.api.report.post('api/reports/sdBridgeReport', bridgeIds).catch(err => { throw err; });
    }
    getSDBridgeSummaryReportData(bridgeIds) {
        return this.api.report.post('api/reports/sdBridgeSummaryReport', bridgeIds).catch(err => { throw err; });
    }
    getHopDetailReportData(objectId) {
        return this.api.report.get('api/reports/hopDetail', { objectId }).catch(err => { throw err; });
    }
    getMunicipalityAssetTipReportData(countyCode, municipalId) {
        return this.api.report.get('api/reports/municipalityAssetTipReport', { countyCode, municipalId }).catch(err => { throw err; });
    }
    getMunicipalityAssetDraftTipReportData(countyCode, municipalId) {
        return this.api.report.get('api/reports/municipalityAssetDraftTipReport', { countyCode, municipalId }).catch(err => { throw err; });
    }
    getLegislativeAssetTipReportData(reportParams) {
        return this.api.report.post('api/reports/legislativeAssetTipReport', reportParams).catch(err => { throw err; });
    }
    getLegislativeAssetDraftTipReportData(reportParams) {
        return this.api.report.post('api/reports/legislativeAssetDraftTipReport', reportParams).catch(err => { throw err; });
    }
    generateCSV(reportParameters) {
        return this.api.report.post('api/csv/getCsvReport', reportParameters).catch(err => { throw err; });
    }
}
ReportsApi.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ReportsApi_Factory() { return new ReportsApi(i0.ɵɵinject(i1.Api)); }, token: ReportsApi, providedIn: "root" });
